import { render, staticRenderFns } from "./ReviewPayment.vue?vue&type=template&id=ff320e1a&scoped=true&"
import script from "./ReviewPayment.vue?vue&type=script&lang=js&"
export * from "./ReviewPayment.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPayment.vue?vue&type=style&index=0&id=ff320e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff320e1a",
  null
  
)

export default component.exports